export default __webpack_public_path__ + "alberta-cloud-upload.3b9715db89d023954306.svg";